<template>
    <section id="transport" class="Transport">
      <h2 class="T__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">Pour le transport</h2>
  
      <!-- Tabs -->
      <div class="T__tabs" role="tablist">
        <button
          v-for="(p,i) in points"
          :key="p.id || i"
          class="T__tab raleway-bold-p16"
          :class="{ active: i===active }"
          role="tab"
          @click="active=i"
        >
          {{ p.city_name }}
        </button>
      </div>
  
      <div class="T__grid" v-if="current">
        <!-- Map -->
        <div class="T__mapWrap">
          <mapbox
            access-token="pk.eyJ1IjoiaG9ydGVuc2VncmVlbiIsImEiOiJja3N1Nm9iNGEwNjUyMm9xY2RlMDlwYWsxIn0.AMGi9L_80RYWk4sB5JYU5w"
            :map-options="mapOptions"
            @map-init="onMapInit"
          />
        </div>
  
        <!-- Cards -->
        <div class="T__right">
          <div class="T__card">
            <div class="T__cardTitle raleway-bold-p16">EN VOITURE</div>
            <div class="T__row">
              <div class="T__k raleway-medi-p15">TEMPS DE TRAJET</div>
              <div class="T__v raleway-medi-p15">{{ current.by_car_time_text }}</div>
              <div class="T__k raleway-medi-p15">DISTANCE</div>
              <div class="T__v raleway-medi-p15">{{ current.by_car_distance_text }}</div>
            </div>
          </div>
  
          <div class="T__card">
            <div class="T__cardTitle raleway-bold-p16">EN TRAIN</div>
  
            <div class="T__row">
              <div class="T__k raleway-medi-p15">TEMPS DE TRAJET</div>
              <div class="T__v raleway-medi-p15">{{ current.by_train_time_text }}</div>
  
              <div class="T__k raleway-medi-p15">GARE DE DÉPART</div>
              <div class="T__v raleway-medi-p15">{{ current.train_departure_station }}</div>
  
              <div class="T__k raleway-medi-p15">GARE D’ARRIVÉE</div>
              <div class="T__v raleway-medi-p15">{{ current.train_arrival_station }}</div>
  
              <div class="T__k raleway-medi-p15">DISTANCE GARE – LIEU DE SÉMINAIRE</div>
              <div class="T__v raleway-medi-p15">{{ current.distance_station_to_venue_text }}</div>
  
              <div class="T__k raleway-medi-p15">OPTION DE TRANSFERT DEPUIS LA GARE D’ARRIVÉE</div>
              <div class="T__v raleway-medi-p15">{{ current.transfer_option_text }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  import Mapbox from 'mapbox-gl-vue';
  import 'mapbox-gl/dist/mapbox-gl.css';
  export default {
    name: 'TransportSection',
    props: {
      points: { type: Array, default: () => [] },
      venue:  { type: Object, default: () => ({ lat: 46.2276, lng: 2.2137 }) }
    },
    components: { Mapbox },
    data(){ return { active: 0, _map: null, markers: [], routeSourceId: 'route-source', routeLayerId: 'route-layer', isPhone: window.innerWidth < 768 } },
    computed: {
      current(){ return this.points[this.active] || null },
      mapCenter(){
        const p = this.current
        const lat = p?.map_latitude ?? this.venue.lat ?? 46.2276
        const lng = p?.map_longitude ?? this.venue.lng ?? 2.2137
        return [lng, lat]
      },
      mapOptions(){
        const isMobile = window.matchMedia('(max-width: 900px)').matches
        return {
          style: isMobile ? 'mapbox://styles/mapbox/streets-v10' : 'mapbox://styles/mapbox/streets-v10',
          zoom: isMobile ? 5.5 : 6.5,
          center: this.mapCenter,
          dragRotate: !isMobile,
          touchZoomRotate: isMobile ? false : true,
          pitchWithRotate: false,
          dragPan: true,
          scrollZoom: true,
          doubleClickZoom: true
        }
      }
    },
    watch:{
      active(){ this.flyMap() }
    },
    methods:{
      onMapInit(map){
        this._map = map
        // Wait for style to load before adding sources/layers
        const initRoute = () => {
          this.initializeRouteLayer()
          this.updateRoute()
        }
        try {
          // Try to initialize immediately
          initRoute()
        } catch (e) {
          // If style not loaded, wait for it
          this._map.on('style.load', initRoute)
        }
      },
      flyMap(){
        if (!this._map) return
        this.clearMarkers()
        // Wait for style to load before updating route
        const updateRouteAndFly = () => {
          try {
            this.updateRoute()
          } catch (e) {
            // Silently fail if route can't be updated yet
          }
          this._map.flyTo({ center: this.mapCenter, zoom: this.mapOptions.zoom, speed: 0.6 })
        }
        try {
          updateRouteAndFly()
        } catch (e) {
          // If style not loaded, wait for it
          this._map.once('style.load', updateRouteAndFly)
        }
      },
      clearMarkers(){
        this.markers.forEach(marker => marker.remove())
        this.markers = []
      },
      addMarker([lng,lat], color){
        if (!this._map) return
        const el = document.createElement('div')
        el.style.width='14px'; el.style.height='14px'; el.style.borderRadius='50%'
        el.style.background=color; el.style.boxShadow='0 0 0 3px rgba(45,95,73,0.25)'
        const marker = new window.mapboxgl.Marker(el, { anchor: 'center' }).setLngLat([lng,lat]).addTo(this._map)
        this.markers.push(marker)
      },
      initializeRouteLayer(){
        if (!this._map) return
        // Add source for route
        if (!this._map.getSource(this.routeSourceId)) {
          this._map.addSource(this.routeSourceId, {
            type: 'geojson',
            data: { type: 'FeatureCollection', features: [] }
          })
        }
        // Add layer for route
        if (!this._map.getLayer(this.routeLayerId)) {
          this._map.addLayer({
            id: this.routeLayerId,
            type: 'line',
            source: this.routeSourceId,
            layout: { 'line-join': 'round', 'line-cap': 'round' },
            paint: { 'line-color': '#2d5f49', 'line-width': 3, 'line-opacity': 0.7, 'line-translate': [0, 10] }
          })
        }
      },
      updateRoute(){
        if (!this._map || !this.current) return
        const p = this.current
        const departureLng = p?.map_longitude
        const departureLat = p?.map_latitude
        const venueLng = this.venue.lng ?? 2.2137
        const venueLat = this.venue.lat ?? 46.2276
        
        // Only draw route if we have valid departure coordinates
        if (departureLng !== undefined && departureLat !== undefined) {
          const routeFeature = {
            type: 'Feature',
            geometry: {
              type: 'LineString',
              coordinates: [[departureLng, departureLat], [venueLng, venueLat]]
            }
          }
          const source = this._map.getSource(this.routeSourceId)
          if (source) {
            source.setData({ type: 'FeatureCollection', features: [routeFeature] })
          }
          // Add markers for departure and arrival
          this.addMarker([departureLng, departureLat], '#ff6b6b')
          this.addMarker([venueLng, venueLat], '#2d5f49')
        }
      }
    }
  }
  </script>
  
  <style scoped>
  /* Title uses Merriweather, tabs/cards use Raleway as inherited from page */
  .T__title{
    color:#0d0d0d;
    text-align:center;
    margin:8px 0 22px;
  }
  
  .T__tabs{
    display:flex; gap:28px; justify-content:center; align-items:center;
    margin-bottom:16px; flex-wrap:wrap;
  }
  .T__tab{
    background:none; border:none; cursor:pointer;letter-spacing:.02em;
    color:#666; padding:8px 6px; position:relative;
  }
  .T__tab.active{ color:#0d0d0d }
  .T__tab.active::after{
    content:""; position:absolute; left:0; right:0; bottom:-6px; height:2px;
    background:#0d0d0d;
  }
  
  .T__grid{ max-width:1200px; margin:0 auto; display:grid; gap:22px; grid-template-columns:1.05fr 1fr; }
  @media(max-width:980px){ .T__grid{ grid-template-columns:1fr } }
  
  .T__mapWrap{
    border-radius:10px; overflow:hidden; border:1px solid #eaeaea; min-height:440px; background:#f0f1f0;
  }
  @media(max-width:980px){ .T__mapWrap{ min-height:320px } }
  
  .T__right{ display:grid; gap:16px; align-content:start }
  
  .T__card{
    background:#f4f6f5; border-radius:10px; padding:18px 20px; border:1px solid #e9ecea;
  }
  .T__cardTitle{
     letter-spacing:.02em; color:#0d0d0d;
    margin-bottom:8px; text-transform:uppercase;
  }
  .T__row{
    display:grid; grid-template-columns: 1fr 1fr; gap:16px 30px; align-items:center;
  }
  @media(max-width:720px){ .T__row{ grid-template-columns:1fr } }
  
  .T__k{
    color:#2d5f49; letter-spacing:.02em;
  }
  .T__v{
    color:#0d0d0d; text-align:right;
  }
  @media(max-width:720px){ .T__v{ text-align:left } }
  </style>
  
